// Création d'un nouvel IntersectionObserver qui écoute si un élément est visible dans le viewport
let observer = new IntersectionObserver((observables) => {

    // On parcourt tous les éléments observés
    observables.forEach((observable) => {
        // Si l'élément est à plus de 25% dans le viewport
        if (observable.intersectionRatio > 0.25) {
            // On retire la classe "not-visible"
            observable.target.classList.remove("not-visible");
        } else {
            // Sinon, on ajoute la classe "not-visible"
            observable.target.classList.add("not-visible");
        }
    });

}, {
    // L'option threshold définit le pourcentage de visibilité à partir duquel l'IntersectionObserver commence à observer l'élément
    threshold: [0.25]
});

// Sélection des éléments de la frise uniquement
// (avant : '.container' ciblait aussi les blocs "P'tite présentation" et "Ma micro-entreprise")
let items = document.querySelectorAll('.timeline .container');

// Pour chaque élément
items.forEach((item) => {
    // On ajoute la classe "not-visible" pour initialement cacher l'élément
    item.classList.add("not-visible");

    // On demande à l'IntersectionObserver d'observer cet élément
    observer.observe(item);
});

// Obtenir la section carrière, son titre et la légende du DOM
const career = document.querySelector('.career');
const careerTitle = career.querySelector('h2');
const legend = document.querySelector('.legend');

const LEGEND_FIXED_TOP = 75; // distance au haut de l'écran quand la légende suit le scroll
const LEGEND_GAP = 10;       // espace entre le titre "Mon périple" et la légende

/**
 * Légende collée à gauche :
 * - au départ, juste sous le titre "Mon périple"
 * - puis elle suit le scroll pendant tout le parcours de la frise
 * - et s'arrête en bas de la section
 */
function updateLegend() {
    // Position de départ (relative à la section, qui est en position: relative)
    const startTop = careerTitle.offsetTop + careerTitle.offsetHeight + LEGEND_GAP;
    const endTop = career.offsetHeight - legend.offsetHeight;
    const careerPageTop = career.getBoundingClientRect().top + window.pageYOffset;
    const scroll = window.pageYOffset + LEGEND_FIXED_TOP;

    legend.style.left = '0px';

    if (scroll <= careerPageTop + startTop) {
        // Avant d'atteindre la légende : sous le titre
        legend.style.position = 'absolute';
        legend.style.top = startTop + 'px';
    } else if (scroll >= careerPageTop + endTop) {
        // Fin de la section : la légende s'arrête en bas
        legend.style.position = 'absolute';
        legend.style.top = endTop + 'px';
    } else {
        // Pendant le parcours de la frise : elle suit le scroll
        legend.style.position = 'fixed';
        legend.style.top = LEGEND_FIXED_TOP + 'px';
    }
}

window.addEventListener('scroll', updateLegend);
window.addEventListener('resize', updateLegend);
window.addEventListener('load', updateLegend);
updateLegend();
